Function::prop = (name, getter) ->
  Object.defineProperty this::, name, get: getter

Function::cprop = (name, getter) ->
  Object.defineProperty this, name, get: getter

_.blank = (value) ->
  !value || $.trim(value) == ''
